import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import BlogPost from './components/BlogPost';
import './App.css';
import { useEffect } from 'react';
import { checkApiConnection } from './utils/CheckAPI';



function App() {

  useEffect(() => {
    // Verificar conexión API al cargar la app
    checkApiConnection();
  }, []);


  return (
    <Router>
      <div className="App">
        <header className="app-header">
          <h1 id='MainTitle'> <a href="/">AoEditor</a> </h1>

        </header>

        <main className="app-main">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/post/:slug" element={<BlogPost />} />
          </Routes>
        </main>

        <footer className="app-footer">
          <p>&copy; 2025 AoEditor. Todos los derechos reservados.</p>
        </footer>
      </div>
    </Router>
  );
}

export default App;